import React from 'react';
import { Editor as IEditor } from 'tinymce';

import { getInsertedGifs } from './textEditorUtils';

export const useIsEditorEmpty = (
    bodyPlaintext: string,
    editorRef: React.MutableRefObject<IEditor | null>
): boolean =>
    React.useMemo(() => {
        if (!editorRef.current) return true;
        return bodyPlaintext.trim() === '' && getInsertedGifs(editorRef.current.getContent()) === null;
    }, [bodyPlaintext]);
